const ListChargebackType = () => import('./ListChargebackType.vue')
const NewChargebackType = () => import('./NewChargebackType.vue')
const EditChargebackType = () => import('./EditChargebackType.vue')
const TheContainer = () => import('@/containers/TheContainer')

export default [
    {
        path: '/admin/chargeback-types',
        name: 'chargebackType',
        component: TheContainer,
        meta: {perms: ['admin.chargeback_type.list']},
        children: [
            {
                path: '',
                name: 'chargebackType.list',
                component: ListChargebackType,
                meta: {label: 'Dispute Types'},
            },
            {
                path: 'new',
                name: 'chargebackType.new',
                component: NewChargebackType,
                meta: {label: 'Create Dispute Type'},
            },
            {
                path: ':id',
                name: 'chargebackType.edit',
                component: EditChargebackType,
                meta: {label: 'Edit Dispute Type'},
            },
        ]
    }
]
